<script>
    import _ from 'lodash'
    import moment from 'moment'
    import Mousetrap from 'mousetrap'
    import $ from '../../plugins/vue-gridform/shared/helper'
    import Helper from '../../utils/helper'
    import {apiComputed, appComputed, authComputed} from '@state/helpers'
    import CONSTANTS from '../../constants'
    import CoachingRun from '../../components/coaching-run'
    import VRatingButton from '../../plugins/vue-gridform/components/v-rating-button'
    import AppFab from '../../components/app-fab'
    import Coaching from './coaching'
    import CoachingAdvancedSearch from '../../components/coaching-advanced-search'
    import SearchSelection from '../../components/search-selection'
    import CoachingCompare from '@components/coaching-compare'
    import TableFooter from '@components/table-footer'
    import CoachingUnitsTable from '@components/coaching-units-table'

    export default {
        components: {
            TableFooter,
            CoachingCompare,
            SearchSelection,
            CoachingAdvancedSearch,
            Coaching,
            AppFab,
            VRatingButton,
            CoachingRun,
            CoachingUnitsTable
        },
        data() {
            return {
                activeTab: 0,
                filterInput: '',
                keyHandler: null,
                dialog: false,
                coaching: null,
                mode: '',
                runAction: null,
                selectStaff: '',
                selectFinished: false,
                expanded: [],
                planning: false,
                advancedSearch: false,
                filter: {},
                loading: false,
                showSelectDialog: false,
                filterSearch: [],
                sort: null,
                lastAction: 'edit',
                activeRow: null,
                coachingsConfigKey: 'vxc-coachings-config',
                tableConfigKey: 'vxc-coachings-tableConfig',
                compareRow: null,
                comparing: false,
                compareRows1: null,
                compareRows2: null,
                directCreate: false,
                rollbackFilter: null,
                showRadar: true,
                editCoachingId: null
            }
        },

        computed: {
            ...authComputed,
            ...appComputed,
            ...apiComputed,
            // includes column based filter functions
            tableHeaders() {
                return [
                    {
                        text: 'ID', value: 'id', width: 0, sortable: false, filterable: false, class: 'hidden', cellClass: 'hidden'
                    },
                    { text: this.$vuetify.lang.t('$vuetify.entity.created'), value: 'created', filter: (value) => {
                            const range = _.pick(this.filter, ['datefrom', 'timefrom', 'dateto', 'timeto'])
                            return $.inDateRange(value, range)
                        }
                    },
                    { text: this.$vuetify.lang.t('$vuetify.entity.employee'), value: 'employeeName', filter: (value, _f, item) => {
                            const employees = _.get(this.filter, 'employees')
                            return _.isEmpty(employees) ? true : employees.includes(item.agentId)
                        }
                    },
                    { text: this.$vuetify.lang.t('$vuetify.entity.template'), value: 'name', filter: (value, _f, item) => {
                            const templates = _.get(this.filter, 'templates')
                            return _.isEmpty(templates) ? true : templates.includes(item.templateId)
                        }
                    },
                    { text: this.$vuetify.lang.t('$vuetify.entity.rating'), value: 'rating', width: '120px', filter: (value) => {
                            const from = _.get(this.filter, 'ratingfrom', 0)
                            const to = _.get(this.filter, 'ratingto', 100)
                            if (from === 0 && to === 100) return true
                            const rating = Math.round(_.get(value, 'percent') || 0)
                            return rating >= from && rating <= to
                        }
                    },
                    { value: 'rating.diff', width: '40px', sortable: false },
                    { text: this.$vuetify.lang.t('$vuetify.entity.duration'), value: 'duration', align: 'end', filter: (value) => {
                            const from = $.durationToSec(_.get(this.filter, 'durationfrom')) || 0
                            const to = $.durationToSec(_.get(this.filter, 'durationto')) || Number.MAX_SAFE_INTEGER
                            return value >= from && value <= to
                        }
                    },
                    { text: this.$vuetify.lang.t('$vuetify.entity.finished'), value: 'finished', filter: (value, _f, item) => {
                            let hasState = true
                            const finished = _.get(this.filter, 'finished')
                            if (finished === 'finished') hasState = !!item.isFinished
                            if (finished === 'not' || typeof finished === 'undefined') hasState = !item.isFinished
                            const range = _.pick(this.filter, ['datefromf', 'timefromf', 'datetof', 'timetof'])
                            if (finished === 'all' && !_.isEmpty(range) && !item.isFinished) return false
                            return hasState && $.inDateRange(value, range)
                        }
                    },
                    { text: this.$vuetify.lang.t('$vuetify.entity.user'), value: 'username', filter: (value, _f, item) => {
                            const coaches = _.get(this.filter, 'coaches')
                            return _.isEmpty(coaches) ? true : coaches.includes(item.username)
                        }
                    },
                    { text: '', value: 'reminder' },
                    { text: this.$vuetify.lang.t('$vuetify.entity.actions'), value: 'actions', sortable: false, align: 'end' }
                ].filter(column => this.userGroup !== CONSTANTS.GROUP_EMPLOYEE_SMART || column.value !== 'employeeName')
            },
            tableItems() {
                if (_.isEmpty(this.coachings) || !_.isArray(this.coachings)) return []
                return this.coachings.map(coaching => _.omit(coaching, ['coachingData']))
            },
            viewTableConfig() {
                let loading = this.loading
                if (this.loading && _.size(this.tableItems)) loading = false
                const tableConfig = this.sort || Helper.getStore(this.tableConfigKey)
                const sortBy = _.get(tableConfig, 'sortBy', 'created')
                const sortDesc = _.get(tableConfig, 'sortDesc')
                const itemsPerPage = _.get(tableConfig, 'itemsPerPage')
                return _.defaultsDeep({
                    table: {
                        headers: this.tableHeaders,
                        items: this.tableItems,
                        sortBy,
                        sortDesc,
                        dense: this.dense,
                        search: this.filterInput,
                        showExpand: this.developerMode,
                        loading,
                        itemsPerPage,
                        // showSelect: true,
                        // singleSelect: true,
                        locale: this.language === 'de' ? 'de_DE' : 'en-US',
                        customFilter: (value, search, item) => {
                            if (this.developerMode && search === '/w') return !!item.ratingIsWeighted // currently only for development
                            const fi = new RegExp(search, 'i')
                            const inId = Helper.isValidId(search) ? fi.test(item.id) : false
                            const inEmployee = fi.test(item.employeeName)
                            const inTemplate = fi.test(item.name)
                            const inGroup = fi.test(item.organizationGroup)
                            return inId || inEmployee || inTemplate || inGroup
                        },
                        footerProps: {
                            itemsPerPageOptions: [5, 10, 20, 50, 100, -1]
                        }
                    },
                    toolbar: {
                        dense: this.dense
                    },
                    title: {
                        class: `font-weight-bold ${this.theme === 'dark' ? 'black--text' : 'white--text'}`
                    }
                }, this.tableConfig)
            },
            sortTable() {
                return (items, sortBy, sortDesc) => {
                    if (_.isEmpty(sortBy)) return items
                    if (_.first(sortBy) === 'rating') {
                        return _.orderBy(items, ['rating.percent', 'created'], [_.first(sortDesc) ? 'desc' : 'asc', 'desc'])
                    }
                    return _.orderBy(items, sortBy, [_.first(sortDesc) ? 'desc' : 'asc'])
                }
            },
            coachings() {
                return this.$store.getters['api/coachings']
            },
            coachingsFilterList() {
                return this.$store.getters['api/coachingsFilterList'][this.organisation.organisationId]
            },
            dialogContentClass() {
                return /^(pdf|print|send)$/.test(this.runAction) ? 'visible-hidden' : null
            },
            ratingOptionsCompare() {
                return {large: false, toggleHint: false, menu: false}
            },
            footerItems() {
                const itemProcess = this.canEdit ? {icon: 'pencil', label: this.$vuetify.lang.t('$vuetify.entity.edit')} : null
                const itemCopy = this.canEdit ? {icon: 'content-copy', label: this.$vuetify.lang.t('$vuetify.entity.clone')} : null
                const itemDelete = this.canDelete ? {icon: 'delete', label: this.$vuetify.lang.t('$vuetify.entity.delete')} : null
                return [
                    {icon: 'clock-alert-outline', label: this.$vuetify.lang.t('$vuetify.entity.reminder'), class: 'mr-10'},
                    itemProcess,
                    {icon: 'card-search', label: this.$vuetify.lang.t('$vuetify.entity.view')},
                    itemCopy,
                    {icon: 'file-compare', label: this.$vuetify.lang.t('$vuetify.entity.compare')},
                    {icon: 'file-pdf-box', label: this.$vuetify.lang.t('$vuetify.entity.pdf')},
                    {icon: 'printer', label: this.$vuetify.lang.t('$vuetify.entity.print')},
                    {icon: 'email-outline', label: this.$vuetify.lang.t('$vuetify.entity.send')},
                    itemDelete
                ]
            },
            showEmployeeName() {
                return this.userGroup !== CONSTANTS.GROUP_EMPLOYEE_SMART
            }
        },
        watch: {
            organisation() {
                this.loading = true
            },
            coachings() {
                this.loading = false
                if (this.editCoachingId) {
                    const coaching = this.coachings.find(c => c.id === this.editCoachingId)
                    this.editCoaching(coaching)
                    this.editCoachingId = null
                }
            },
            filterInput(value) {
                // this.$highlight(value, 'td', CONSTANTS.DEFAULT_HIGHLIGHT_OPTIONS)
            },
            lastAction(lastAction) {
                Helper.updateStore(this.coachingsConfigKey, {lastAction})
            }
        },

        created() {
            const config = Helper.getStore(this.coachingsConfigKey)
            this.lastAction = _.get(config, 'lastAction', '')
            this.showRadar = _.get(config, 'showRadar', true)
        },
        mounted() {
            this._bindKeys()
            this.$autofocus('#app-fab')
            // ## check route query
            // create: true -> start planning
            // advanced: true -> open advanced search form
            // ## check route params
            // id: xy -> filter id
            // action: ["view" | "edit" | "create"]
            this.$nextTick(() => {
                const query = _.extend({}, this.$route.params, this.$route.query)
                if (query.create || query.action === 'create') {
                    this.directCreate = true
                    this.planning = true
                    return
                }

                if (query.action === 'view' && query.id) this.viewCoaching({id: query.id})
                if (query.action === 'edit' && query.id) this.editCoaching({id: query.id})

                const cas = this.$refs.cas
                if (cas) {
                    if (/^true$/.test(query.advanced)) cas.toggle(false) // set collapsed to false
                    if (cas.gf) {
                        const code = query.code
                        const date = query.date
                        let values = !query.action && query.id
                            ? {filtertext: query.id, finished: 'all'}
                            : _.omit(query, ['advanced', 'code', 'date'])
                        if (!_.isEmpty(values)) {
                            values = {...values, ...$.codeToQuery(code, date)}
                            // template field has multiple prop and must be an array
                            if (values.templates && _.isString(values.templates)) values.templates = values.templates.split(',')
                            // TODO check if reset is needed
                            cas.gf.reset() // when query exists, reset values from store (coachingsFilter)
                            cas.gf.values(values)
                        }
                    }
                }
            })
        },
        beforeDestroy() {
            this._unbindKeys()
        },

        methods: {
            _bindKeys() {
                this.keyHandler = e => {
                    if (e.code === 'F2' && !this.planning) this.planning = true
                    if (e.code === 'F9' && !this.planning) this.advancedSearch = !this.advancedSearch
                    if (e.code === 'Escape' && this.planning) this.planning = false
                }
                document.addEventListener('keydown', this.keyHandler, true)
                Mousetrap.bind('* f', () => {
                    this.$refs.cas.toggle()
                })
            },
            _unbindKeys() {
                document.removeEventListener('keydown', this.keyHandler, true)
                Mousetrap.unbind('* f')
            },

            ratingOptions(item) {
                return {
                    absolute: false,
                    labelPercent: true,
                    rating: item.rating,
                    width: '2',
                    xSmall: this.dense
                }
            },
            ratingLabel(item) {
                const { label } = item.rating
                return label || ''
            },
            ratingLabelDiff(item) {
                const { diff } = item.rating
                return diff ? this.$numeral(diff, CONSTANTS.FORMAT_RATING) : ''
            },
            showRating(item) {
                // TODO if only coaching reminder is set, coachingDate and username is set and the "no rating" info is displayed
                if (!item.finished && !item.coachingDate && !item.username && !item.duration) return false
                return !!item.rating
            },
            recalcRating(item) {
                if (!item || !item.id) return
                const coaching = this.coachings.find(c => c.id === item.id)
                if (!coaching) return

                // console.log('item', JSON.stringify(item, null, 2))
                // console.log('coaching', Helper.coachingToConfig(coaching))
                const rows = Helper.coachingToConfig(coaching)
                // const rows = Helper.coachingToRows(coaching)
                // console.log('rows', rows)
                console.log('$.ratings', $.ratings(rows))
                console.log('rating', Helper.coachingToRating(coaching))
                console.log('group rating', Helper.coachingToGroupsRating(coaching))
                _.each(_.flatten(rows), col => {
                    if (col.rating) {
                        // console.log('col.rating', JSON.stringify(col.rating, null, 2))
                        // console.log('recalc', JSON.stringify($.rating(col), null, 2))
                    }
                })
            },
            recalcRatings() {
                let wrong = 0
                this.coachings.forEach(coaching => {
                    const recalced = $.ratings(Helper.coachingToConfig(coaching))
                    if (coaching.rating.percent !== recalced.percent) {
                        console.log('coaching.rating.percent', coaching.rating.percent, recalced.percent)
                        wrong++
                    }
                    if (Math.round(coaching.rating.percent) !== coaching.score) {
                        console.log('coaching.rating.percent, coaching.score', coaching.rating.percent, coaching.score, coaching)
                        wrong++
                    }
                })
                console.log('wrong', wrong)
            },
            showJSON(item) {
                if (!item || !item.id) return
                const coaching = this.coachings.find(c => c.id === item.id)
                if (!coaching) return

                this.$json.open(coaching)
            },
            hasRating(item) {
                return item.rating.score && item.rating.max
            },

            async editCoaching(item) {
                if (!item || !item.id) return
                const coaching = this.coachings.find(c => c.id === item.id)
                if (!coaching) return

                if (coaching.isFinished) {
                    const submitted = await this.$gridform.dialog({
                        message: this.$vuetify.lang.t('$vuetify.coaching.edit'),
                        text: this.$vuetify.lang.t('$vuetify.coaching.editHint'),
                        submit: this.$vuetify.lang.t('$vuetify.actions.edit')
                    })
                    if (!submitted) return
                }

                this.lastAction = 'edit'
                this.mode = 'edit'
                this.runAction = null
                this.dialog = true
                this.coaching = {...coaching, staffName: item.employeeName}
            },
            async deleteCoaching(coaching) {
                this.lastAction = 'delete'
                const submitted = await this.$gridform.dialog({
                    message: this.$vuetify.lang.t('$vuetify.coaching.delete'),
                    text: coaching.name,
                    description: `${this.$vuetify.lang.t('$vuetify.entity.employee')}: ${coaching.employeeName}`,
                    submit: this.$vuetify.lang.t('$vuetify.actions.delete')
                })
                if (!submitted) return

                await this.$store.dispatch('api/COACHING_DELETE', coaching)
            },
            viewCoaching(item) {
                if (!item || !item.id) return
                const coaching = this.coachings.find(c => c.id === item.id)
                if (!coaching) return

                this.lastAction = 'view'
                this.mode = 'view'
                this.runAction = null
                this.dialog = true
                this.coaching = {...coaching, staffName: item.employeeName}
            },
            async cloneCoaching(item) {
                if (!item || !item.id) return
                const coaching = this.coachings.find(c => c.id === item.id)
                if (!coaching) return

                const cloneCoaching = await this.$gridform.dialog({
                    message: this.$vuetify.lang.t('$vuetify.coaching.clone'),
                    text: this.$vuetify.lang.t('$vuetify.coaching.cloneHint'),
                    submit: this.$vuetify.lang.t('$vuetify.actions.clone'),
                    width: 480
                })
                if (!cloneCoaching) return

                const userId = coaching.agentId
                const name = coaching.name
                const organisationId = this.organisation.organisationId
                const isFinished = false
                // reset values
                const coachingData = Helper.resetConfigValues(coaching.coachingData)
                const payload = {userId, name, organisationId, coachingData, isFinished}

                await this.$store.dispatch('api/COACHING_CREATE', payload)
            },
            editPlanning(item) {
                this.closePlanning()
                // set id and check in watch "coachings" to start editing the coaching
                this.editCoachingId = item.id
            },
            compareCoaching(item) {
                if (!item || !item.id) return
                const coaching = this.coachings.find(c => c.id === item.id)
                if (!coaching) return

                const _rollback = () => {
                    this.compareRow = null
                    this.$refs.cas.updateFilter({templates: {value: this.rollbackFilter.templates}})
                    this.rollbackFilter = null
                }

                if (this.compareRow && this.compareRow.id === coaching.id) return _rollback() // do not compare same coaching
                if (this.compareRow && this.compareRow.templateId !== coaching.templateId) return // only compare same templates

                // first coaching already selected
                // create rows definition for both coachings
                // open all fieldlists
                // rollback search filter
                // open compare dialog
                if (this.compareRow) {
                    this.compareRows1 = Helper.coachingToConfig(this.compareRow)
                    this.compareRows2 = Helper.coachingToConfig(coaching)

                    // prepend rating information
                    const flRating = {initials: '_RATING'}
                    this.compareRows1.unshift([{type: 'divider', fieldlist: flRating}])
                    this.compareRows1.unshift([
                        {type: 'text', label: this.$vuetify.lang.t('$vuetify.entity.note'), value: this.compareRow.rating.hint, dense: true, size: 11, fieldlist: flRating},
                        {type: 'ratingbutton', options: this.compareRow.rating, size: 1, dense: true, disabled: true, fieldlist: flRating}
                    ])
                    this.compareRows2.unshift([{type: 'divider', fieldlist: flRating}])
                    this.compareRows2.unshift([
                        {type: 'text', label: this.$vuetify.lang.t('$vuetify.entity.note'), value: coaching.rating.hint, dense: true, size: 11, fieldlist: flRating},
                        {type: 'ratingbutton', options: coaching.rating, size: 1, dense: true, disabled: true, fieldlist: flRating}
                    ])
                    // append coaching information (duration, finished, ..)
                    const flCoaching = {initials: '_COACHING'}
                    const finishedDateLabel = this.$vuetify.lang.t('$vuetify.entity.finishedDate')
                    const finishedTimeLabel = this.$vuetify.lang.t('$vuetify.entity.finishedTime')
                    const durationLabel = this.$vuetify.lang.t('$vuetify.entity.duration')
                    this.compareRows1.unshift([
                        {type: 'date', label: finishedDateLabel, value: this.compareRow.finished, dense: true, fieldlist: flCoaching},
                        {type: 'time', label: finishedTimeLabel, value: this.compareRow.finished, dense: true, fieldlist: flCoaching},
                        {type: 'text', label: durationLabel, value: this.formatDuration(this.compareRow.duration), dense: true, fieldlist: flCoaching}
                    ])
                    this.compareRows2.unshift([
                        {type: 'date', label: finishedDateLabel, value: coaching.finished, dense: true, fieldlist: flCoaching},
                        {type: 'time', label: finishedTimeLabel, value: coaching.finished, dense: true, fieldlist: flCoaching},
                        {type: 'text', label: durationLabel, value: this.formatDuration(coaching.duration), dense: true, fieldlist: flCoaching}
                    ])
                    // prepend template information (initials, name, description)
                    const flTemplate = {initials: '_TEMPLATE'}
                    const initialsLabel = this.$vuetify.lang.t('$vuetify.entity.initials')
                    const nameLabel = this.$vuetify.lang.t('$vuetify.entity.name')
                    this.compareRows1.unshift([
                        {type: 'text', label: initialsLabel, value: this.compareRow.templateInitials, dense: true, size: 4, fieldlist: flTemplate},
                        {type: 'text', label: nameLabel, value: this.compareRow.name, dense: true, fieldlist: flTemplate}
                    ])
                    this.compareRows2.unshift([
                        {type: 'text', label: initialsLabel, value: coaching.templateInitials, dense: true, fieldlist: flTemplate},
                        {type: 'text', label: nameLabel, value: coaching.name, dense: true, fieldlist: flTemplate}
                    ])

                    // open all fieldlists: set fieldlist collapsed state to false
                    _.flatten(this.compareRows1).forEach(field => {
                        if (field.fieldlist && !field.fieldlist.internal && field.fieldlist.initials.charAt(0) !== '_') {
                            field.fieldlist.collapsed = false
                        }
                    })
                    _.flatten(this.compareRows2).forEach(field => {
                        if (field.fieldlist && !field.fieldlist.internal && field.fieldlist.initials.charAt(0) !== '_') {
                            field.fieldlist.collapsed = false
                        }
                    })
                    // reset compare workflow
                    _rollback()
                    // open compare dialog
                    this.comparing = true
                }
                    // set last action for coaching actions in table row
                    // store first selected coaching for compare
                    // save current search filter for rollback
                // set filter for first template for first selected coaching
                else {
                    this.lastAction = 'compare'
                    this.compareRow = coaching
                    // TODO filter selected template?
                    this.rollbackFilter = _.clone(this.filter)
                    this.$refs.cas.updateFilter({templates: {value: [coaching.templateId]}})
                }
            },
            toggleRadar(showRadar) {
                Helper.updateStore(this.coachingsConfigKey, {showRadar})
            },

            pdfCoaching(item) {
                if (!item || !item.id) return
                const coaching = this.coachings.find(c => c.id === item.id)
                if (!coaching) return

                this.lastAction = 'pdf'
                this.mode = 'view'
                this.runAction = 'pdf'
                this.dialog = true
                this.coaching = {...coaching, staffName: item.employeeName}
            },
            printCoaching(item) {
                if (!item || !item.id) return
                const coaching = this.coachings.find(c => c.id === item.id)
                if (!coaching) return

                this.lastAction = 'print'
                this.mode = 'view'
                this.runAction = 'print'
                this.dialog = true
                this.coaching = {...coaching, staffName: item.employeeName}
            },
            async sendCoaching(item) {
                if (!item || !item.id) return
                const coaching = this.coachings.find(c => c.id === item.id)
                if (!coaching) return

                this.lastAction = 'send'
                this.mode = 'view'
                this.runAction = 'send'
                this.dialog = true
                this.coaching = {...coaching, staffName: item.employeeName}
            },

            async saveSearch() {
                const cas = this.$refs.cas
                const block = cas ? _.get(_.first(cas.gf.fieldlist()), 'fieldlist') : {}

                const data = await this.$gridform.dialog({
                    title: this.$vuetify.lang.t('$vuetify.search.saveTitle'),
                    input: {
                        label: this.$vuetify.lang.t('$vuetify.search.saveName'),
                        spellcheck: false
                    },
                    submit: this.$vuetify.lang.t('$vuetify.actions.apply')
                })
                if (!data) return

                const name = data.inputText
                const filter = this.filter
                let description = ''
                _.each(block.descriptions, d => {
                    if (description) description += ', '
                    description += `${d.text}`
                })
                const table = this.$refs.table
                const sort = _.pick(table, ['sortBy', 'sortDesc', 'itemsPerPage'])
                this.$store.commit('api/ADD_COACHINGS_FILTER', {filter, name, description, sort})
            },
            onFilterChange(filter) {
                filter = _.omit(filter, ['advanced'])
                if (_.isEqual(this.filter, filter)) return

                this.filter = filter
                this.filterInput = _.get(this.filter, 'filtertext', '') // sync text filter for table
                this.$store.commit('api/UPDATE_COACHINGS_FILTER', this.filter)
            },
            onSelectSearch(selected) {
                if (_.isEmpty(selected)) return

                const search = _.first(selected)
                this.showSelectDialog = false
                this.$refs.cas.gf.reset()
                this.$refs.cas.gf.values(search.filter)
                this.sort = search.sort
                this.filterSearch = []
            },
            onDeleteSearch(search) {
                this.$store.commit('api/DELETE_COACHINGS_FILTER', search)
            },

            close() {
                this.dialog = false
                this.runAction = null
            },
            closePlanning() {
                this.planning = false
            },

            itemsPerPage(itemsPerPage) {
                Helper.updateStore(this.tableConfigKey, {itemsPerPage})
            },
            sortBy(sortBy) {
                Helper.updateStore(this.tableConfigKey, {sortBy})
            },
            sortDesc(sortDesc) {
                Helper.updateStore(this.tableConfigKey, {sortDesc})
            },
            setActiveRow(row) {
                this.activeRow = row.id
            },

            exportTableXlsx() {
                const {headers, items, efu} = this.getExportHeaders()
                if (_.isEmpty(items)) return // nothing to export

                const title = 'Coachings'
                const filename = `${title}.xlsx`

                const hasRatingDiff = !!_.find(items, item => {
                    return _.get(item, 'rating.diff')
                })
                const data = []
                const header = []
                const max = {}
                let text

                // TODO do not use headers from table, we must be flexible for export without putting all fields in the table
                _.each(headers, col => {
                    text = col.text || ''
                    if (col.value === 'rating.diff' && hasRatingDiff) {
                        text = this.$vuetify.lang.t('$vuetify.entity.ratingWeighted')
                    }
                    if (text) {
                        header.push(text)
                        max[col.value] = text.length
                    }
                })
                data.push(header)

                _.each(items, coaching => {
                    const row = []
                    row.push(coaching.id)
                    row.push(coaching.created)
                    row.push(coaching.employeeName)
                    row.push(coaching.name)
                    row.push(coaching.rating)
                    if (hasRatingDiff) row.push(coaching.rating && coaching.rating.diff ? coaching.rating.diff.toFixed(2) : '')
                    row.push(coaching.duration)
                    row.push(coaching.finished)
                    row.push(coaching.username)
                    row.push(coaching.reminderDate)
                    _.each(efu, ef => {
                        const score = this.getExportFieldScore(coaching.exportFields, ef.label)
                        row.push(score)
                        max[ef.label] = Math.max(max[ef.label], `${score}`.length)
                    })
                    data.push(row)
                    max.employeeName = Math.max(max.employeeName, coaching.employeeName.length)
                    max.name = Math.max(max.name, coaching.name.length)
                    max.username = Math.max(max.username, coaching.username.length)
                })

                const colInfo = []
                colInfo.push({width: 40}) // id
                colInfo.push({width: 30}) // created
                colInfo.push({width: max.employeeName + 5})
                colInfo.push({width: max.name + 5})
                colInfo.push({width: max.rating + 5})
                if (hasRatingDiff) colInfo.push({width: max['rating.diff'] + 5})
                colInfo.push({width: max.duration + 5})
                colInfo.push({width: 30}) // finished
                colInfo.push({width: max.username + 5})
                colInfo.push({width: 30}) // reminder
                _.each(efu, ef => {
                    colInfo.push({width: max[ef.label] + 5})
                })

                this.$xlsx({title, data, colInfo, filename})
            },
            exportTable() {
                const {headers, items, efu} = this.getExportHeaders()
                if (_.isEmpty(items)) return // nothing to export

                const hasRatingDiff = !!_.find(items, item => {
                    return _.get(item, 'rating.diff')
                })

                let csvContent = ''
                let text
                _.each(headers, column => {
                    text = column.text || ''
                    if (column.value === 'rating.diff' && hasRatingDiff) {
                        text = this.$vuetify.lang.t('$vuetify.entity.ratingWeighted')
                    }
                    if (text) csvContent += (text || '') + CONSTANTS.COLUMN_DELIMITER
                })
                csvContent += CONSTANTS.ROW_DELIMITER

                _.each(items, item => {
                    let row = ''
                    row += item.id + CONSTANTS.COLUMN_DELIMITER
                    row += item.created + CONSTANTS.COLUMN_DELIMITER
                    row += item.employeeName + CONSTANTS.COLUMN_DELIMITER
                    row += item.name + CONSTANTS.COLUMN_DELIMITER
                    row += item.rating + CONSTANTS.COLUMN_DELIMITER
                    if (hasRatingDiff) row += (item.rating && item.rating.diff ? item.rating.diff.toFixed(2) : '') + CONSTANTS.COLUMN_DELIMITER
                    row += item.duration + CONSTANTS.COLUMN_DELIMITER
                    row += item.finished + CONSTANTS.COLUMN_DELIMITER
                    row += item.username + CONSTANTS.COLUMN_DELIMITER
                    row += item.reminderDate + CONSTANTS.COLUMN_DELIMITER
                    _.each(efu, ef => {
                        const score = this.getExportFieldScore(item.exportFields, ef.label)
                        row += score + CONSTANTS.COLUMN_DELIMITER
                    })
                    row += CONSTANTS.ROW_DELIMITER
                    csvContent += row
                })

                // TODO charset= or encoding: ?
                Helper.download(csvContent, 'coachings.csv', 'text/csv;charset=utf-8;')
                // Helper.download(csvContent, 'coachings.csv', 'text/csv;encoding:utf-8')
            },
            getExportHeaders() {
                const reminderText = this.$vuetify.lang.t('$vuetify.entity.reminder')
                const headers = []
                _.each(this.tableHeaders, col => {
                    if (col.value !== 'actions') {
                        headers.push({
                            value: col.value,
                            text: col.value !== 'reminder' ? col.text : reminderText
                        })
                    }
                })
                const items = _.cloneDeep(_.get(this.$refs, 'table.$children.0.filteredItems'))
                // collect headers from fields to export
                const ef = []
                _.each(items, item => {
                    const coaching = _.find(this.coachings, c => c.id === item.id)
                    item.exportFields = Helper.findExportFields(coaching)
                    item.created = moment.utc(item.created).local().format()
                    item.finished = item.finished ? moment.utc(item.finished).local().format() : ''
                    item.reminder = item.reminderDate ? moment.utc(item.reminderDate).local().format() : ''
                    item.username = item.username || ''
                    item.employeeName = item.employeeName || ''
                    item.name = item.name || ''
                    item.rating = item.rating ? item.rating.percent.toFixed(2) : ''
                    ef.push(item.exportFields)
                })
                const efu = _.uniqBy(_.flatten(ef), 'label')
                _.each(efu, item => {
                    headers.push({value: item.label, text: item.label})
                })
                return {headers, items, efu}
            },
            getExportFieldScore(exportFields, label) {
                const f = _.find(exportFields, {label})
                let score = _.get(f, 'rating.score')
                // if export field has no score, we export the input value
                if (_.isUndefined(score)) {
                    let value = !f ? '' : _.isUndefined(f.value) ? '' : f.value
                    if (_.isArray(value)) value = value.map(v => v.label).toString()
                    if (f && f.type === 'radio') {
                        const itemValue = _.find(f.items, item => item.value === value)
                        if (itemValue) value = itemValue.label
                    }
                    if (!_.isBoolean(value)) value = value || ''
                    else value = `${value}`
                    score = value
                }
                return score
            },

            expandItem(item) {
                if (!this.expanded.includes(item)) this.expanded.push(item)
            },
            collapseItem(item) {
                this.expanded = this.expanded.filter(row => row !== item)
            },

            rowClass(coaching) {
                let _class = ''
                if (this.activeRow === coaching.id) _class += 'vxc-coachings--active '
                if (this.compareRow && this.compareRow.id === coaching.id) _class += 'vxc-coachings--compare '
                return _class.trim()
            },
            formatDate(date) {
                return date ? moment.utc(date).local().format(this.formatter.datetime) : ''
            },
            formatDuration(duration) {
                return duration ? $.formatTimestamp(duration * 1000, false) : ''
            }
        }
    }
</script>

<template>
    <VLayout class="justify-center position-relative">
        <VFlex xs12 xl10 class="pa-2 px-md-8">
            <VTabs v-model="activeTab" background-color="primary" dark class="mb-2">
                <VTab>{{ $vuetify.lang.t('$vuetify.routes.coaching') }}</VTab>
                <VTab>{{ $vuetify.lang.t('$vuetify.coachingUnit.label') }}</VTab>
            </VTabs>

            <CoachingUnitsTable v-if="activeTab === 1" class="pa-0"/>

            <template v-if="activeTab === 0">
            <VDataTable
                ref="table"
                v-bind="viewTableConfig.table"
                :custom-sort="sortTable"
                :expanded.sync="expanded"
                @update:items-per-page="itemsPerPage"
                @update:sort-by="sortBy"
                @update:sort-desc="sortDesc">
                <!-- Toolbar -->
                <template #top>
                    <VToolbar v-bind="viewTableConfig.toolbar">
                        <VToolbarTitle v-bind="viewTableConfig.title">Coachings</VToolbarTitle>
                        <VDivider class="mx-4" inset vertical dark/>
                        <VSpacer/>
                        <!-- Select saved search -->
                        <VTooltip bottom>
                            <template v-slot:activator="{ on }">
                                <VBtn icon :disabled="!coachingsFilterList || !coachingsFilterList.length" :light="theme === 'dark'" :dark="theme !== 'dark'" v-on="on" @click.left="showSelectDialog = true">
                                    <VIcon>mdi-table-search</VIcon>
                                </VBtn>
                            </template>
                            <span>{{ $vuetify.lang.t('$vuetify.search.saveSelect') }}</span>
                        </VTooltip>
                        <!-- Save search -->
                        <VTooltip bottom>
                            <template v-slot:activator="{ on }">
                                <VBtn icon :light="theme === 'dark'" :dark="theme !== 'dark'" v-on="on" @click.left="saveSearch">
                                    <VIcon>mdi-content-save-outline</VIcon>
                                </VBtn>
                            </template>
                            <span>{{ $vuetify.lang.t('$vuetify.search.saveTitle') }}</span>
                        </VTooltip>
                        <!-- Export buttons in toolbar on medium screen and larger -->
                        <template v-if="!$vuetify.breakpoint.smAndDown">
                            <VDivider class="mx-4" inset vertical dark/>
                            <!-- Export XLSX -->
                            <VTooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <VBtn icon :light="theme === 'dark'" :dark="theme !== 'dark'" v-on="on" @click.left="exportTableXlsx">
                                        <VIcon>mdi-file-excel-outline</VIcon>
                                    </VBtn>
                                </template>
                                <span>{{ $vuetify.lang.t('$vuetify.actions.exportXlsx') }}</span>
                            </VTooltip>
                            <!-- Export CSV -->
                            <VTooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <VBtn icon :light="theme === 'dark'" :dark="theme !== 'dark'" v-on="on" @click.left="exportTable">
                                        <VIcon>mdi-file-export-outline</VIcon>
                                    </VBtn>
                                </template>
                                <span>{{ $vuetify.lang.t('$vuetify.actions.csv') }}</span>
                            </VTooltip>
                        </template>
                        <!-- otherwise put them in dropdown menu -->
                        <VMenu v-else :close-on-content-click="true" bottom left>
                            <template v-slot:activator="{ on }">
                                <VBtn icon :light="theme === 'dark'" :dark="theme !== 'dark'" v-on="on">
                                    <VIcon>mdi-dots-vertical</VIcon>
                                </VBtn>
                            </template>

                            <VList dense>
                                <VListItem @click.left="exportTableXlsx">
                                    <VListItemIcon>
                                        <VIcon>mdi-file-excel-outline</VIcon>
                                    </VListItemIcon>
                                    <VListItemContent>
                                        <VListItemTitle>{{ $vuetify.lang.t('$vuetify.actions.exportXlsx') }}</VListItemTitle>
                                    </VListItemContent>
                                </VListItem>
                                <VListItem @click.left="exportTable">
                                    <VListItemIcon>
                                        <VIcon>mdi-file-export-outline</VIcon>
                                    </VListItemIcon>
                                    <VListItemContent>
                                        <VListItemTitle>{{ $vuetify.lang.t('$vuetify.actions.csv') }}</VListItemTitle>
                                    </VListItemContent>
                                </VListItem>
                            </VList>
                        </VMenu>
                    </VToolbar>
                    <CoachingAdvancedSearch ref="cas" v-model="advancedSearch" @change="onFilterChange"/>
                </template>

                <template v-slot:item="{ item, isExpanded }">
                    <tr :class="rowClass(item)" @click.left="setActiveRow(item)">
                        <template v-if="viewTableConfig.table.showExpand">
                            <td v-if="!isExpanded" class="pl-2 pr-1"><VIcon v-if="!item.valid" @click.left="expandItem(item)">mdi-chevron-down</VIcon></td>
                            <td v-else class="pl-2 pr-1"><VIcon v-if="!item.valid" @click.left="collapseItem(item)">mdi-chevron-up</VIcon></td>
                        </template>
                        <td class="hidden"></td>
                        <td>
                            <span class="vc-coaching__created vc-monospace text-no-wrap">{{ formatDate(item.created) }}</span>
                        </td>
                        <td v-if="showEmployeeName">{{ item.employeeName }}</td>
                        <td>{{ item.name }}</td>
                        <td>
                            <div v-if="showRating(item)" class="text-no-wrap">
                                <template v-if="hasRating(item)">
                                    <VRatingButton :options="ratingOptions(item)"/>
                                    <span class="vc-coaching__rating-label d-inline-block vc-monospace" v-text="ratingLabel(item)"></span>
                                </template>
                                <span v-else v-text="$vuetify.lang.t('$vuetify.coaching.noRatingHint')"></span>
                            </div>
                        </td>
                        <td class="text-right">
                            <span v-if="hasRating(item)" class="vc-coaching__rating-diff d-inline-block vc-monospace" v-text="ratingLabelDiff(item)"></span>
                        </td>
                        <td class="text-right">
                            <span class="vc-monospace">{{ formatDuration(item.duration) }}</span>
                        </td>
                        <td>
                            <VCheckbox v-model="item.isFinished" class="mt-0 pt-0 d-inline-block" dense hide-details disabled :ripple="false"/>
                            <span class="vc-monospace vc-coaching__finished text-no-wrap" v-text="formatDate(item.finished)"></span>
                        </td>
                        <td>{{ item.username }}</td>
                        <td>
                            <VIcon v-if="item.reminderDate" small class="mdi mdi-clock-alert-outline" :class="item.overdue ? 'red--text' : ''" :title="formatDate(item.reminderDate)"/>
                        </td>
                        <td v-if="!runAction" class="text-right">
                            <!-- All actions in column (large screens) -->
                            <div v-if="$vuetify.breakpoint.xlOnly" class="text-no-wrap">
                                <VBtn v-if="canEdit" icon small @click.left="editCoaching(item)">
                                    <VIcon small class="mdi mdi-pencil"></VIcon>
                                </VBtn>
                                <VBtn icon small @click.left="viewCoaching(item)">
                                    <VIcon small class="mdi mdi-card-search"></VIcon>
                                </VBtn>
                                <VBtn v-if="canEdit" icon small @click.left="cloneCoaching(item)">
                                    <VIcon small class="mdi mdi-content-copy"></VIcon>
                                </VBtn>
                                <VBtn icon small @click.left="compareCoaching(item)">
                                    <VIcon small class="mdi mdi-file-compare"></VIcon>
                                </VBtn>
                                <VBtn icon small @click.left="pdfCoaching(item)">
                                    <VIcon small class="mdi mdi-file-pdf-box"></VIcon>
                                </VBtn>
                                <VBtn icon small @click.left="printCoaching(item)">
                                    <VIcon small class="mdi mdi-printer"></VIcon>
                                </VBtn>
                                <VBtn icon small @click.left="sendCoaching(item)">
                                    <VIcon small class="mdi mdi-email-outline"></VIcon>
                                </VBtn>
                                <VBtn v-if="canDelete" icon small @click.left="deleteCoaching(item)">
                                    <VIcon small class="mdi mdi-delete"></VIcon>
                                </VBtn>
                            </div>
                            <!-- One action and menu trigger in column (smaller screens) -->
                            <div v-else class="text-no-wrap">
                                <!-- Display last used action in front of menu -->
                                <VBtn v-if="canEdit && lastAction === 'edit'" icon small @click.left="editCoaching(item)">
                                    <VIcon small class="mdi mdi-pencil"></VIcon>
                                </VBtn>
                                <VBtn v-if="lastAction === 'compare'" icon small @click.left="compareCoaching(item)">
                                    <VIcon small class="mdi mdi-file-compare"></VIcon>
                                </VBtn>
                                <VBtn v-if="!lastAction || lastAction === 'view'" icon small @click.left="viewCoaching(item)">
                                    <VIcon small class="mdi mdi-card-search"></VIcon>
                                </VBtn>
                                <VBtn v-if="canDelete && lastAction === 'delete'" icon small @click.left="deleteCoaching(item)">
                                    <VIcon small class="mdi mdi-delete"></VIcon>
                                </VBtn>
                                <VBtn v-if="lastAction === 'pdf'" icon small @click.left="pdfCoaching(item)">
                                    <VIcon small class="mdi mdi-file-pdf-box"></VIcon>
                                </VBtn>
                                <VBtn v-if="lastAction === 'print'" icon small @click.left="printCoaching(item)">
                                    <VIcon small class="mdi mdi-printer"></VIcon>
                                </VBtn>
                                <VBtn v-if="lastAction === 'send'" icon small @click.left="sendCoaching(item)">
                                    <VIcon small class="mx-2 mdi mdi-email-outline"></VIcon>
                                </VBtn>

                                <!-- Dropdown on smaller screens -->
                                <VMenu :close-on-content-click="true" bottom left>
                                    <template v-slot:activator="{ on }">
                                        <VBtn icon small v-on="on">
                                            <VIcon>mdi-dots-vertical</VIcon>
                                        </VBtn>
                                    </template>

                                    <VList dense>
                                        <VListItem v-if="canEdit" @click.left="editCoaching(item)">
                                            <VListItemIcon>
                                                <VIcon>mdi-pencil</VIcon>
                                            </VListItemIcon>
                                            <VListItemContent>
                                                <VListItemTitle>{{ $vuetify.lang.t('$vuetify.entity.edit') }}</VListItemTitle>
                                            </VListItemContent>
                                        </VListItem>
                                        <VListItem @click.left="viewCoaching(item)">
                                            <VListItemIcon>
                                                <VIcon>mdi-card-search</VIcon>
                                            </VListItemIcon>
                                            <VListItemContent>
                                                <VListItemTitle>{{ $vuetify.lang.t('$vuetify.entity.view') }}</VListItemTitle>
                                            </VListItemContent>
                                        </VListItem>
                                        <VListItem v-if="canEdit" @click.left="cloneCoaching(item)">
                                            <VListItemIcon>
                                                <VIcon>mdi-content-copy</VIcon>
                                            </VListItemIcon>
                                            <VListItemContent>
                                                <VListItemTitle>{{ $vuetify.lang.t('$vuetify.entity.clone') }}</VListItemTitle>
                                            </VListItemContent>
                                        </VListItem>
                                        <VListItem @click.left="compareCoaching(item)">
                                            <VListItemIcon>
                                                <VIcon>mdi-file-compare</VIcon>
                                            </VListItemIcon>
                                            <VListItemContent>
                                                <VListItemTitle>{{ $vuetify.lang.t('$vuetify.entity.compare') }}</VListItemTitle>
                                            </VListItemContent>
                                        </VListItem>
                                        <VDivider v-if="canEdit"/>
                                        <VListItem @click.left="pdfCoaching(item)">
                                            <VListItemIcon>
                                                <VIcon>mdi-file-pdf-box</VIcon>
                                            </VListItemIcon>
                                            <VListItemContent>
                                                <VListItemTitle>{{ $vuetify.lang.t('$vuetify.entity.pdfcreate') }}</VListItemTitle>
                                            </VListItemContent>
                                        </VListItem>
                                        <VListItem @click.left="printCoaching(item)">
                                            <VListItemIcon>
                                                <VIcon>mdi-printer</VIcon>
                                            </VListItemIcon>
                                            <VListItemContent>
                                                <VListItemTitle>{{ $vuetify.lang.t('$vuetify.entity.print') }}</VListItemTitle>
                                            </VListItemContent>
                                        </VListItem>
                                        <VListItem @click.left="sendCoaching(item)">
                                            <VListItemIcon>
                                                <VIcon>mdi-email-outline</VIcon>
                                            </VListItemIcon>
                                            <VListItemContent>
                                                <VListItemTitle>{{ $vuetify.lang.t('$vuetify.entity.send') }}</VListItemTitle>
                                            </VListItemContent>
                                        </VListItem>
                                        <VDivider v-if="canDelete"/>
                                        <VListItem v-if="canDelete" @click.left="deleteCoaching(item)">
                                            <VListItemIcon>
                                                <VIcon>mdi-delete</VIcon>
                                            </VListItemIcon>
                                            <VListItemContent>
                                                <VListItemTitle>{{ $vuetify.lang.t('$vuetify.entity.delete') }}</VListItemTitle>
                                            </VListItemContent>
                                        </VListItem>
                                    </VList>
                                </VMenu>
                            </div>
                        </td>
                        <td v-else class="text-center">
                            <VProgressCircular size="16" width="2" indeterminate/>
                        </td>
                    </tr>
                </template>

                <!-- Expansion panel -->
                <template v-slot:expanded-item="{ item, headers }">
                    <tr>
                        <td :colspan="headers.length - 2" class="pa-3">{{ item }}</td>
                        <td>
                            <VBtn text small @click.left="recalcRating(item)">Rating</VBtn>
                            <VBtn text small @click.left="recalcRatings">Recalc</VBtn>
                            <VBtn text small @click.left="showJSON(item)">JSON</VBtn>
                        </td>
                    </tr>
                </template>
            </VDataTable>
            <TableFooter :items="footerItems"/>
            </template><!-- end activeTab === 0 -->
        </VFlex>

        <VDialog v-model="dialog" :content-class="dialogContentClass" persistent no-click-animation fullscreen>
            <CoachingRun v-model="dialog" :coaching="coaching" :mode="mode" :action="runAction" @close="close"/>
        </VDialog>

        <AppFab v-if="canEdit && activeTab === 0" icon="mdi-plus" @click="planning = true"/>
        <VDialog v-if="canEdit" v-model="planning" persistent no-click-animation fullscreen>
            <Coaching v-model="planning" @edit="editPlanning" @close="closePlanning"/>
        </VDialog>

        <VDialog v-model="comparing" persistent no-click-animation fullscreen>
            <CoachingCompare
                :rows1="compareRows1"
                :rows2="compareRows2"
                :rating="ratingOptionsCompare"
                :show-radar="showRadar"
                @radar="toggleRadar"
                @close="comparing = false"
            />
        </VDialog>

        <VDialog v-model="showSelectDialog" max-width="80%">
            <VSheet>
                <SearchSelection
                    v-model="filterSearch"
                    :items="coachingsFilterList"
                    :title="$vuetify.lang.t('$vuetify.search.saveSelect')"
                    elevation="0"
                    single-select
                    @change="onSelectSearch"
                    @delete="onDeleteSearch"
                    @close="showSelectDialog = false"
                />
            </VSheet>
        </VDialog>
    </VLayout>
</template>

<style>
    .vxc-coachings--active {
        background-color: #DEDEDE;
    }
    .vxc-coachings--compare {
        background-color: rgba(10, 180, 185, 0.1) !important;
    }
    .vc-coaching__finished {
        vertical-align: text-bottom;
    }
    .vc-coaching__rating-label {
        min-width: 64px;
        padding-left: 4px;
        text-align: right;
    }
    th.hidden,
    td.hidden {
        display: none;
        padding: 0;
    }
</style>
